import type { SpfBucketFileFrontend } from "./BotDocument.ts";

export const FustionTypeArr = [
  'captivate',
  'htmlpage',
  'html-as-media',
  "iframely_vimeo",
  'knowledgeworker',
  'lxt',
  'miro-by-url',
  'miro-by-template',
  'rise',
  "storyline",
  'video',
  'youtube'

] as const;
export type FustionType = typeof FustionTypeArr[number]
export const iframelyFusionTypeArr = ["miro"] as const; // hier können auch andere dinge rein youtube kommt aber erstmal rauis
export type IframelyFusionType = typeof iframelyFusionTypeArr[number]
export type FusionContent<ID> =
  FusionContentHtmlAsMedia<ID> |
  FusionContentKnowledgeWorker<ID> |
  FusionContentLxt<ID> |
  FusionContentMiroByTemplate<ID> |
  FusionContentMiroByUrl<ID> |
  FusionContentCaptivate<ID> |
  FusionContentStoryline<ID> |
  FusionContentHtmlPage<ID> |
  FusionContentRise<ID> |
  FusionContentVideo<ID> |
  FusionContentIframely<ID> |
  FusionContentYoutube<ID>;

export type DefaultFusionContent<ID = string> = {
  bottype: string,
  botlang: string,
  botId: ID,
  name: string,
  title: string,
  sortFloat: number;
  botHidden: boolean // default false
  botButtonHidden: boolean // default false
  viewMode: string // "window", "full", "float" -> default "split"
  disclaimerPlacement: 'botview' | 'fusionview'
}

export type FusionContentHtmlPage<ID = string> = DefaultFusionContent<ID> & {
  type: "htmlpage"
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  customJS: string
}

export type FusionContentHtmlPageNew<ID = string> = DefaultFusionContent<ID> & {
  type: "htmlpage-new"
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  customJS: string
}
export type FusionContentHtmlAsMedia<ID = string> = DefaultFusionContent<ID> & {
  type: "html-as-media"
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  customJS: string
}

export type FusionContentRise<ID = string> = DefaultFusionContent<ID> & {
  type: "rise"
  customJS: string,
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  uploader: string
}

export type FusionContentStoryline<ID = string> = DefaultFusionContent<ID> & {
  type: "storyline"
  customJS: string,
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  uploader: string
}


export type FusionContentMiroByTemplate<ID = string> = DefaultFusionContent<ID> & {
  type: "miro-by-template"
  customJS: string,
  editadble: boolean,
  autoplay: boolean,
  templateId: string
}

export type FusionContentMiroByUrl<ID = string> = DefaultFusionContent<ID> & {
  type: "miro-by-url"
  customJS: string,
  editadble: boolean,
  autoplay: boolean,
  boardId: string
}

export type FusionContentLxt<ID = string> = DefaultFusionContent<ID> & {
  type: "lxt"
  customJS: string,
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  uploader: string
}


export type FusionContentKnowledgeWorker<ID = string> = DefaultFusionContent<ID> & {
  type: "knowledgeworker"
  customJS: string,
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  uploader: string
}
export type FusionContentCaptivate<ID = string> = DefaultFusionContent<ID> & {
  type: "captivate"
  customJS: string,
  proxyUrl: string,
  staticHtml: string,
  useStaticHtml: boolean
  uploader: string
}

export type FusionContentVideo<ID = string> = DefaultFusionContent<ID> & {
  type: "video"
  indexHtml: string,
  onSeek: string
  onEnd: string
}

export type FusionContentYoutube<ID = string> = DefaultFusionContent<ID> & {
  type: "youtube"
  videoId: string,
  customJS: string,
  staticHtml: string,
  useStaticHtml: boolean
  proxyUrl: string,
  //PLAYER PARAMS https://developers.google.com/youtube/player_parameters
  pv_autoplay: 0 | 1
  pv_cc_lang_pref: string // video lang preference oder "default"
  pv_cc_load_policy: 0 | 1 | "default"
  pv_color: "red" | "white"
  pv_controls: 0 | 1 //def: 1 playercontrols
  pv_disablekb: 0 | 1 //def: 1 keyboard controlls
  pv_end: number | "default" //endSeconds
  pv_fs: 0 | 1 //def 1 fullscreen
  pv_hl: string // player language oder "default"
  pv_iv_load_policy: 1 | 3 //def: 1 videoannotations
  pv_loop: 0 | 1
  pv_rel: 0 | 1 // empfehlungen 0:eigener channel 1:alle youtube videos
  pv_start: number | "default"
  //origin,playlist,playsinline, widget_referrer.. some missing
}

export type FusionContentIframely<ID = string> = DefaultFusionContent<ID> & {
  bottype: string,
  botlang: string,
  type: "iframely"
  botId: ID
  url: string,
  html: string,
  iframelyType: string
  staticHtml: string,
  useStaticHtml: boolean
  proxyUrl: string,
  customJS: string,

  pv_autoplay: 0 | 1
  pv_loop: 0 | 1
  pv_controls: 0 | 1
  pv_fs: 0 | 1
}

export type FusionRiseDefaults = Pick<FusionContentRise, "staticHtml" | "useStaticHtml" | "proxyUrl" | "customJS">
export type FusionVideoDefaults = Pick<FusionContentVideo, "indexHtml">
export type FusionDefaults = FusionRiseDefaults | FusionVideoDefaults
export type FusionFileFrontend = SpfBucketFileFrontend<FusionContent<string>>;